var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "d-flex flex-row mt-3" },
    [
      _c(
        "div",
        { staticClass: "justify-content-start" },
        [
          _vm.unreadAnnouncements
            ? _c("a-badge", { attrs: { color: "#F64E60" } }, [
                _c(
                  "span",
                  {
                    staticClass: "material-icons",
                    staticStyle: { "font-size": "20px !important" },
                  },
                  [_vm._v("dvr")]
                ),
              ])
            : _c(
                "span",
                {
                  staticClass: "material-icons",
                  staticStyle: { "font-size": "20px !important" },
                },
                [_vm._v("dvr")]
              ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "b-modal",
              rawName: "v-b-modal.announcement",
              modifiers: { announcement: true },
            },
          ],
          staticClass: "justify-content-end pl-3 popoverFont cursorPointer",
          on: { click: _vm.showModal },
        },
        [
          _vm._v(
            "\n        " + _vm._s(_vm.$t("message.announcements")) + "\n    "
          ),
        ]
      ),
      _vm._v(" "),
      _vm.isModalShow
        ? _c(
            "Modal2",
            {
              attrs: {
                id: "announcement",
                "show-footer": false,
                title: _vm.$t("message.announcements"),
              },
              on: { cancel: _vm.hideModal },
            },
            [
              !!_vm.announcements.length
                ? _c("div", { staticClass: "d-block" }, [
                    _c(
                      "div",
                      { staticClass: "accordion", attrs: { role: "tablist" } },
                      _vm._l(_vm.announcements, function (ann, index) {
                        return _c(
                          "b-card",
                          {
                            key: index,
                            staticClass: "mb-1",
                            attrs: { "no-body": "" },
                          },
                          [
                            _c(
                              "b-card-header",
                              {
                                staticClass: "p-1",
                                attrs: { "header-tag": "header", role: "tab" },
                              },
                              [
                                _c(
                                  "b-button",
                                  {
                                    directives: [
                                      {
                                        name: "b-toggle",
                                        rawName: "v-b-toggle",
                                        value: "accordion-" + index,
                                        expression: "'accordion-' + index",
                                      },
                                    ],
                                    staticClass: "w-100",
                                    attrs: { block: "" },
                                  },
                                  [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          ann.languageContent[_vm.language.code]
                                            .title_
                                        )
                                      ),
                                    ]),
                                    _vm._v(
                                      "\n                            -\n                            "
                                    ),
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm
                                            .$moment(ann.createdAt)
                                            .format("LLL")
                                        )
                                      ),
                                    ]),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-collapse",
                              {
                                attrs: {
                                  id: "accordion-" + index,
                                  visible: "",
                                  accordion: "my-accordion",
                                  role: "tabpanel",
                                },
                              },
                              [
                                _c(
                                  "b-card-body",
                                  [
                                    _c("b-card-text", {
                                      domProps: {
                                        innerHTML: _vm._s(
                                          ann.languageContent[_vm.language.code]
                                            .description_
                                        ),
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      }),
                      1
                    ),
                  ])
                : _c("div", { staticClass: "d-block text-center" }, [
                    _c("p", { staticClass: "my-4" }, [
                      _vm._v(_vm._s(_vm.$t("message.noNewAnnouncement"))),
                    ]),
                  ]),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }